import styled from 'styled-components';

export const Container = styled.div<{ fullHeight: boolean }>`
  ${({ fullHeight }) => fullHeight && 'height: 100%;'}

  .formContainer {
    padding-top: 20px;
  }
`;
